import { render, staticRenderFns } from "./TotalWidgetType.vue?vue&type=template&id=3404cbe8&"
import script from "./TotalWidgetType.vue?vue&type=script&lang=js&"
export * from "./TotalWidgetType.vue?vue&type=script&lang=js&"
import style0 from "./TotalWidgetType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports